module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_5.b09c3d00.jpg";